import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPocRoute = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-flask-conical",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2" }),
		/* @__PURE__ */ _jsx("path", { d: "M6.453 15h11.094" }),
		/* @__PURE__ */ _jsx("path", { d: "M8.5 2h7" })
	]
});
export default SvgPocRoute;
